module.exports = __webpack_public_path__ + "static/Contact-706388215c7ecb79cda5d2a79628d953.png";